import { fontStyles } from '@/styles/typography';

import { ExternalLink } from '@/ui/Link/ExternalLink';

import { routes } from '@/utils/routes';

import { StyledParagraph, StyledPrimaryCell } from '../../SwapTokens/utils';
import { ZeroExLogo } from './ZeroExLogo';

export function DEXAggregatorSection({ hideContentText = false }) {
  return (
    <StyledPrimaryCell className="rounded-b-[2.25rem] flex flex-col tablet:flex-row items-center tablet:justify-between tablet:py-14 tablet:pl-14 mb-20 desktop:h-[160px]">
      <div className="flex flex-col desktop:flex-row text-center tablet:text-left items-center tablet:items-start desktop:items-center">
        <h2
          className={fontStyles({
            variant: 'H2',
            class: [
              'max-w-[284px]',
              'text-token-gray-700',
              'font-bold',
              'mb-8',
              'desktop:mb-0',
              'desktop:mr-20',
            ],
          })}
        >
          DEX aggregator built by{' '}
          <ExternalLink
            href={routes.ZEROEX_HOME}
            className="text-1000 font-bold text-token-gray-1600"
          >
            0x
          </ExternalLink>
        </h2>
        {!hideContentText && (
          <StyledParagraph className="max-w-[270px]">
            Experience friction-free Web3 with meta transactions using cutting-edge crypto-native
            infrastructure.
          </StyledParagraph>
        )}
      </div>
      <ExternalLink href={routes.ZEROEX_HOME}>
        <ZeroExLogo
          classNameAnimation="transition-transform duration-500 ease-in-out transform-gpu origin-center [svg:hover_&:nth-child(1)]:scale-[1.11] [svg:hover_&:nth-child(2)]:scale-[1.03] [svg:hover_&:nth-child(3)]:scale-[1.24] [svg:hover_&:nth-child(4)]:scale-[1.15]"
          className="mt-14 -mb-[120px] tablet:-mt-[110px] tablet:-mr-[50px]"
        />
      </ExternalLink>
    </StyledPrimaryCell>
  );
}
